import React from 'react';

import * as Icon from 'react-feather';
// const tenantId = localStorage.getItem("tenantId") || null;
export const SidebarData = [
      {
        label: "Inventory",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Inventory",
        key: "manage_products",
      
        submenuItems: [
          { key: "products", label: "Products", link: "/product-list", icon:<Icon.Box />,showSubRoute: false,submenu: false },
          { key: "category", label: "Category", link: "/category-list", icon:  <Icon.Codepen />,showSubRoute: false,submenu: false },
          { key: "sub_category", label: "Sub Category", link: "/sub-categories", icon:  <Icon.Speaker  />,showSubRoute: false,submenu: false },
          { key: "brands", label: "Brands", link: "/brand-list", icon:  <Icon.Tag />,showSubRoute: false,submenu: false },
          { key: "variant_attributes", label: "Variant Attributes", link: "/variant-attributes", icon:  <Icon.Layers />,showSubRoute: false,submenu: false },
        ]
      },
      {
        label: "Outgoing Inventory",
        submenuOpen: true,
        submenuHdr: "Orders",
        submenu: false,
        showSubRoute: false,
        key: "Outgoing Inventory",
        submenuItems: [
          
          { key: "orders", label: "Orders",  link: "/salelist", icon:  <Icon.ShoppingCart />,showSubRoute: false,submenu: false },
          { key: "refund_request", label: "Refund Request", link: "/refunds", icon:  <Icon.CreditCard />,showSubRoute: false,submenu: false },
        ]
      },
      {
        label: "Incoming Inventory",
        submenuOpen: true,
        submenuHdr: "Purchases",
        showSubRoute: false,
        key: "Incoming Inventory",
        submenuItems: [
          { key: "purchases", label: "Purchases", link: "/purchase-list", icon:  <Icon.ShoppingBag />,showSubRoute: false,submenu: false },
        ]
      },
      {
        label: "Reports",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Reports",
        key: "reports",

        submenuItems: [
           { key: "customers_record", label: "Customers Record", link: "/customers", icon:  <Icon.Users />,showSubRoute: false, submenu: false },
          { 
            key: "receivables",
            label: "Receivables",
            link: "/receivables",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
        ]
      },
      {
        label: "People",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "People",
        key: "trade_directory",
      
        submenuItems: [
           { key: "managecustomers", label: "Manage Customers", link: "/managecustomers", icon:  <Icon.Users />,showSubRoute: false, submenu: false },
          { key: "suppliers", label: "Suppliers", link: "/suppliers", icon:  <Icon.Users />,showSubRoute: false, submenu: false },
          { key: "stores", label: "Stores", link: "/store-list", icon:  <Icon.Home  />,showSubRoute: false,submenu: false },
          
          // {
          //   key: "import-data",
          //   label: "Import",
          //   link: "/import-data",
          //   icon: <Icon.Users />,
          //   showSubRoute: false,
          // },
                   
         
          
          { key: "product_bidding", label: "Product Bidding", link: "/productBidding", icon:  <Icon.Users />,showSubRoute: false, submenu: false },
         
          
        ]
      },
      {
        label: "User Management",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "User Management",
        key: "user_management",
      
        submenuItems: [
          { 
            key: "users",
            label: "Users",
            link: "/users",
            icon: <Icon.Users />,
            showSubRoute: false,
            submenu: false
          },
          {
            key: "roles-permissions",
            label: "Roles & Permissions",
            link: "/roles-permissions",
            icon: <Icon.UserCheck />,
            showSubRoute: false,
            submenu: false
          },
          {
            key: "tenant_settings",
            label: "Tenant Settings",
            link: "/tenant-settings",
            icon: <Icon.User />,
            showSubRoute: false,
            submenu: false
          },
        ]
      },
  
     
      {
        label: "Social Media",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Social Media",
        key: "social_media",
      
        submenuItems: [
         
          {
            key: "socialconnect",
            label: "Connect",
            link: "/socialconnect",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },      
          {
            key: "scheduling_ai",
            label: "Scheduling Ai",
            link: "/socialmedia-scheduling-ai",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
          {
            key: "video-scheduling-ai",
            label: "Video Scheduling Ai",
            link: "/socialmedia-video-scheduling-ai",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
           {
            key: "whattsapp-messages",
            label: "WhattsApp Messages",
            link: "/whattsapp-messages",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
        ]
      },

       {
        label: "Integrations",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Integrations",
        key: "integrations",
      
        submenuItems: [
         {
            key: "taacaa-integration",
            label: "Taacaa Integration",
            link: "/taacaa-integration",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
          {
            key: "payment-gateways",
            label: "Payment Gateways",
            link: "/payment-gateways",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
        
           {
            
            key: "couriers",
            label: "Couriers",
            link: "/couriers",
            icon: <Icon.CreditCard />,
            showSubRoute: false,
            submenu: false
          },
        ]
      },
      //  {
      //   label: "Settings",
      //   submenuOpen: true,
      //   showSubRoute: false,
      //   submenuHdr: "Settings",
      //   submenuItems: [
     
      //     {
      //       label: "Users",
      //       link: "/users",
      //       icon: <Icon.Users />,
      //       showSubRoute: false,
      //     },
      //     {
      //       label: "Roles & Permissions",
      //       link: "/roles-permissions",
      //       icon: <Icon.UserCheck />,
      //       showSubRoute: false,
      //     },
      //   ],
      // },
]

    // {
    //     label: "Main",
    //     submenuOpen: true,
    //     showSubRoute: false,
    //     submenuHdr: "Main",
    //     submenuItems: [
    //     {
    //         label: "Dashboard",
    //         icon: <Icon.Grid  />,
    //         submenu: true,
    //         showSubRoute: false,

    //         submenuItems: [
    //           { label: "Admin Dashboard", link: "/" },
    //           { label: "Sales Dashboard", link: "/sales-dashboard" }
    //         ]
    //       },
    //       {
    //         label: "Application",
    //         icon:  <Icon.Smartphone />,
    //         submenu: true,
    //         showSubRoute: false,
    //         submenuItems: [
    //           { label: "Chat", link: "/chat" , showSubRoute: false,
    //         },
    //           {
    //             label: "Call",
    //             submenu: true,
    //             submenuItems: [
    //               { label: "Video Call", link: "/video-call" },
    //               { label: "Audio Call", link: "/audio-call" },
    //               { label: "Call History", link: "/call-history" }
    //             ]
    //           },
    //           { label: "Calendar", link: "/calendar" , showSubRoute: false,
    //         },
    //           { label: "Email", link: "/email",showSubRoute: false,
    //         },
    //           { label: "To Do", link: "/todo",showSubRoute: false,
    //         },
    //           { label: "Notes", link: "/notes",showSubRoute: false,
    //         },
    //           { label: "File Manager", link: "/file-manager", showSubRoute: false,
    //         }
    //         ]
    //       }
    //     ]
    //   },